export const avatarOptions = {
    "topType": {
      "key": "topType",
      "available": 1,
      "options": [
        "NoHair",
        "Eyepatch",
        "Hat",
        "Hijab",
        "Turban",
        "WinterHat1",
        "WinterHat2",
        "WinterHat3",
        "WinterHat4",
        "LongHairBigHair",
        "LongHairBob",
        "LongHairBun",
        "LongHairCurly",
        "LongHairCurvy",
        "LongHairDreads",
        "LongHairFrida",
        "LongHairFro",
        "LongHairFroBand",
        "LongHairNotTooLong",
        "LongHairShavedSides",
        "LongHairMiaWallace",
        "LongHairStraight",
        "LongHairStraight2",
        "LongHairStraightStrand",
        "ShortHairDreads01",
        "ShortHairDreads02",
        "ShortHairFrizzle",
        "ShortHairShaggyMullet",
        "ShortHairShortCurly",
        "ShortHairShortFlat",
        "ShortHairShortRound",
        "ShortHairShortWaved",
        "ShortHairSides",
        "ShortHairTheCaesar",
        "ShortHairTheCaesarSidePart"
      ],
      "defaultValue": "LongHairStraight"
    },
    "accessoriesType": {
      "key": "accessoriesType",
      "available": 1,
      "options": [
        "Blank",
        "Kurt",
        "Prescription01",
        "Prescription02",
        "Round",
        "Sunglasses",
        "Wayfarers"
      ],
      "defaultValue": "Blank"
    },
    "hatColor": {
      "key": "hatColor",
      "available": 1,
      "options": [
        "Black",
        "Blue01",
        "Blue02",
        "Blue03",
        "Gray01",
        "Gray02",
        "Heather",
        "PastelBlue",
        "PastelGreen",
        "PastelOrange",
        "PastelRed",
        "PastelYellow",
        "Pink",
        "Red",
        "White"
      ],
      "defaultValue": "Red"
    },
    "hairColor": {
      "key": "hairColor",
      "available": 0,
      "options": [
        "Auburn",
        "Black",
        "Blonde",
        "BlondeGolden",
        "Brown",
        "BrownDark",
        "PastelPink",
        "Blue",
        "Platinum",
        "Red",
        "SilverGray"
      ],
      "defaultValue": "BrownDark"
    },
    "facialHairType": {
      "key": "facialHairType",
      "available": 1,
      "options": [
        "Blank",
        "BeardMedium",
        "BeardLight",
        "BeardMajestic",
        "MoustacheFancy",
        "MoustacheMagnum"
      ],
      "defaultValue": "Blank"
    },
    "facialHairColor": {
      "key": "facialHairColor",
      "available": 1,
      "options": [
        "Auburn",
        "Black",
        "Blonde",
        "BlondeGolden",
        "Brown",
        "BrownDark",
        "Platinum",
        "Red"
      ],
      "defaultValue": "BrownDark"
    },
    "clotheType": {
      "key": "clotheType",
      "available": 1,
      "options": [
        "BlazerShirt",
        "BlazerSweater",
        "CollarSweater",
        "GraphicShirt",
        "Hoodie",
        "Overall",
        "ShirtCrewNeck",
        "ShirtScoopNeck",
        "ShirtVNeck"
      ],
      "defaultValue": "BlazerShirt"
    },
    "clotheColor": {
      "key": "clotheColor",
      "available": 1,
      "options": [
        "Black",
        "Blue01",
        "Blue02",
        "Blue03",
        "Gray01",
        "Gray02",
        "Heather",
        "PastelBlue",
        "PastelGreen",
        "PastelOrange",
        "PastelRed",
        "PastelYellow",
        "Pink",
        "Red",
        "White"
      ],
      "defaultValue": "Gray01"
    },
    "graphicType": {
      "key": "graphicType",
      "available": 1,
      "options": [
        "Bat",
        "Cumbia",
        "Deer",
        "Diamond",
        "Hola",
        "Pizza",
        "Resist",
        "Selena",
        "Bear",
        "SkullOutline",
        "Skull"
      ],
      "defaultValue": "Skull"
    },
    "eyeType": {
      "key": "eyeType",
      "available": 1,
      "options": [
        "Close",
        "Cry",
        "Default",
        "Dizzy",
        "EyeRoll",
        "Happy",
        "Hearts",
        "Side",
        "Squint",
        "Surprised",
        "Wink",
        "WinkWacky"
      ],
      "defaultValue": "Default"
    },
    "eyebrowType": {
      "key": "eyebrowType",
      "available": 1,
      "options": [
        "Angry",
        "AngryNatural",
        "Default",
        "DefaultNatural",
        "FlatNatural",
        "RaisedExcited",
        "RaisedExcitedNatural",
        "SadConcerned",
        "SadConcernedNatural",
        "UnibrowNatural",
        "UpDown",
        "UpDownNatural"
      ],
      "defaultValue": "Default"
    },
    "mouthType": {
      "key": "mouthType",
      "available": 1,
      "options": [
        "Concerned",
        "Default",
        "Disbelief",
        "Eating",
        "Grimace",
        "Sad",
        "ScreamOpen",
        "Serious",
        "Smile",
        "Tongue",
        "Twinkle",
        "Vomit"
      ],
      "defaultValue": "Default"
    },
    "skinColor": {
      "key": "skinColor",
      "available": 1,
      "options": [
        "Tanned",
        "Yellow",
        "Pale",
        "Light",
        "Brown",
        "DarkBrown",
        "Black"
      ],
      "defaultValue": "Light"
    }
  }